import { Record } from "immutable";
import { TranslationState } from "./types";

export const createTranslationState = Record<TranslationState>({
    translations: undefined
});
